module.exports = __webpack_public_path__ + "img/thumb8.edf2dee1.jpg";